import { connect } from 'react-redux';
import { ConfirmModal } from 'app/react/components/_index';
import * as actions from 'app/react/state/actions/_index';
import * as Item from 'app/react/entities/accounts/items/index';
import * as State from './ItemModalState';

const TITLE = 'Delete Item';
const TEXT = (name) => `Are you sure you want to delete <strong>${name}?</strong>`;
const BUTTON_TEXT =  'Yes, delete item';
const FAILED_POPUP = 'Failed to delete item.';
const SUCCESSFUL_POPUP = 'Item successfully deleted.';

const mapStateToProps = (state) => {
    const {
        isOpened,
        isSyncing,
        item = {},
    } = State.getDeleteModalState(state);
    return {
        title: TITLE,
        text: TEXT(item.name),
        buttonText: BUTTON_TEXT,
        buttonClassName: 'alert',
        isOpened,
        isSyncing,
        item,
    };
};

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
    onConfirmed: () => {
        const { item } = stateProps;
        dispatchProps.onConfirmed(item.id);
    }
});

const mapDispatchToProps = (dispatch) => ({
    onClosed: () => {
        dispatch((State.setDeleteModalStateValue('isOpened', false)));
    },
    onConfirmed: (itemId) => {
        dispatch((State.setDeleteModalStateValue('isSyncing', true)));
        dispatch(Item.thunks.deleteOneForCurrentContext(itemId))
            .then(({ isFailure, errorMessage }) => {
                if (isFailure) {
                    dispatch(actions.showErrorPopup(`${FAILED_POPUP} ${errorMessage}`));
                    dispatch(State.mergeDeleteModalState({
                        isSyncing: false
                    }));
                } else {
                    dispatch(actions.showSuccessPopup(SUCCESSFUL_POPUP));
                    dispatch(State.mergeDeleteModalState({
                        isOpened: false,
                        isSyncing: false
                    }));
                }
            });
    }
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
)(ConfirmModal);
